// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer":"blog-tags_tagsContainer__bxCM6"};